import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { FiMail, FiMapPin } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { key: 'home', to: { pathname: '/' } },
    { key: 'investment', to: { pathname: '/', hash: '#investment' } },
    { key: 'construction', to: { pathname: '/', hash: '#construction' } },
    { key: 'materials', to: { pathname: '/', hash: '#materials' } }
  ];

  const services = t('footer.servicesList', { returnObjects: true });


  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <div className="footer-logo">
              <img src="/dldmn-logo-final.svg" alt="DLDMN Baumanagement GmbH" className="footer-logo-image" />
              <h3>DLDMN Baumanagement</h3>
              <p>{t('footer.description')}</p>
            </div>
            <div className="contact-info">
              <div className="contact-item">
                <FiMapPin />
                <span style={{ color: 'black' }}>Markstraße 37, 13409 Berlin</span>
              </div>
              <div className="contact-item">
                <FiMail />
                <span style={{ color: 'black' }}>info@dldmn-baumanagement.de</span>
              </div>
            </div>
          </motion.div>

          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            <h4>{t('footer.quickLinks')}</h4>
            <ul className="footer-links">
              {quickLinks.map((link) => (
                <li key={link.key}>
                  <Link to={link.to}>
                    {t(`nav.${link.key}`)}
                  </Link>
                </li>
              ))}
            </ul>
          </motion.div>

          <motion.div
            className="footer-section"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <h4>{t('footer.services')}</h4>
            <ul className="footer-links">
              {services.map((service, index) => (
                <li key={index}>
                  <span>{service}</span>
                </li>
              ))}
            </ul>
          </motion.div>
        </div>

        <motion.div
          className="footer-bottom"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
        >
          <p>© {currentYear} DLDMN Baumanagement GmbH. {t('footer.rights')}</p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
